import { useAPI } from "../../../../../api/useAPI";
import { useCallback } from "react";
import { ConfirmModal } from "../../../../../components/ConfirmModal.tsx";
import { DBAccount } from "../../../../../api/types";
import { Typography } from "@mui/material";

interface Props {
  reloadAccounts: () => void;
  handleClose: () => void;
  open: boolean;
  account: DBAccount;
}

export default ({ open, handleClose, account, reloadAccounts }: Props) => {
  const { disableAccount } = useAPI();

  const handleConfirm = useCallback(async () => {
    try {
      const result = await disableAccount(account._id.toString(), true);

      if (!result.success) {
        return { error: result.error || "Failed to archive account" };
      }

      return { success: "Account archived successfully" };
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : "An error occurred";
      return { error: errorMessage };
    }
  }, [account, disableAccount]);

  const closeWrapper = useCallback(() => {
    reloadAccounts();
    handleClose();
  }, [handleClose]);

  const { name } = account;

  return (
    <ConfirmModal
      handleClose={closeWrapper}
      handleConfirm={handleConfirm}
      open={open}
      title={"Archive account"}
    >
      <Typography color="textPrimary">
        Are you sure you want to archive the account "{name}" and remove it from
        the dashboard.
      </Typography>
      <Typography color="textPrimary">
        It will still exist in the database, but will nog longer trade.
      </Typography>
      <Typography color="warning" sx={{ mt: 1 }}>
        Note! Open positions will NOT be closed.
      </Typography>
    </ConfirmModal>
  );
};
